<template>
  <el-switch v-bind="$attrs" v-on="$listeners" class="rt-switch" />
</template>

<script>
export default {
  name: 'RtSwitch'
}
</script>

<style lang="less" scoped>
@deep: ~'>>>';
.rt-switch.el-switch {
  height: 24px;
  line-height: 24px;
  &.is-checked{
    @{deep} {
      .el-switch__core {
        background:#1890ff;
        border: 1px solid #1890ff;
        &::after {
          width: 20px;
          height: 20px;
          margin-left: -21px;
        }
      }
    }
  }
  @{deep} {
    .el-switch__core {
      width: 48px!important;
      height: 24px;
      border-radius: 22px;
      background:#a9c2e8;
      border: 1px solid #a9c2e8;
      &::after {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtSwitch.vue?6a05c1e1